function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 22,
  r: 22,
  fill: "black"
});

var _ref2 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_539_12894)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 22,
  r: 27,
  fill: "#323232"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_539_12894)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.9912 12C18.3803 12 16.668 15.4258 17.9862 18.3281C17.8217 18.4336 17.5577 18.7637 17.6125 19.3438C17.7222 20.3984 18.2158 20.6504 18.49 20.7031C18.5997 21.7051 19.2598 22.873 19.6437 23.0312C19.6437 23.7168 19.6336 24.291 19.5787 25.0312C18.7378 27.1543 13.3631 26.6621 12.6725 30.4688C12.642 30.6348 12.8208 31 13.1762 31H30.84C31.3681 31 31.358 30.625 31.3275 30.4531C30.6247 26.6621 25.2622 27.1523 24.4212 25.0312C24.3664 24.2383 24.3562 23.7168 24.3562 23.0312C24.7402 22.873 25.3516 21.6523 25.4613 20.7031C25.7355 20.7031 26.1742 20.3848 26.3387 19.3281C26.3936 18.748 26.1681 18.3809 25.9487 18.3281C26.8263 17.2734 26.6678 12.9531 23.43 12.9531L22.9912 12ZM16.8812 14.5C13.4098 14.5566 11.8884 17.2129 12.9325 19.4844C12.8208 19.5371 12.6014 19.8164 12.6562 20.2969C12.768 21.1523 13.0991 21.3594 13.3225 21.3594C13.4322 22.1602 13.9237 23.0586 14.2 23.2188C14.2 23.752 14.2061 23.7363 14.1512 24.375C13.7003 25.7422 9 25.6406 9 29C9 29 9 29.5 9.52 29.5H11.8762C12.6705 27.3398 14.8297 26.5078 16.4587 25.8906C17.3566 25.5508 18.2767 25.207 18.555 24.7812C18.5855 24.3164 18.6017 23.9219 18.6037 23.4844C18.1102 22.9414 17.7425 22.0957 17.5637 21.375C17.1412 21.0742 16.6842 20.4961 16.5725 19.4219C16.5237 18.9121 16.6355 18.4883 16.8162 18.1562C16.4039 16.9238 16.4303 15.6367 16.8812 14.5ZM28.76 14.5C28.2623 14.5 27.6753 14.5391 27.1187 14.625C27.5352 15.7988 27.5514 17.2012 27.1838 18.2031C27.3462 18.5469 27.4214 18.9648 27.3787 19.4219L27.3625 19.4531V19.4844C27.2081 20.4668 26.8323 21.0645 26.3875 21.3906C26.2189 22.0664 25.8756 22.9199 25.3962 23.4688C25.3983 23.8984 25.4145 24.2852 25.445 24.7812C25.7233 25.207 26.6455 25.5508 27.5413 25.8906C29.1683 26.5059 31.3275 27.3398 32.1237 29.5H34.48C35 29.5 35 29.0156 35 29.0156C35.002 25.1484 30.5495 26.0645 29.8812 24.2969C29.8244 23.707 29.8162 23.7617 29.8162 23.1719C30.0945 23.0117 30.6064 22.1113 30.6612 21.3594C30.8847 21.3594 31.2158 21.1387 31.3275 20.2812C31.3823 19.8535 31.2178 19.5371 31.0512 19.4844C31.7216 18.627 31.6119 15.25 29.1012 15.25L28.76 14.5Z",
  fill: "white"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_539_12894"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "white",
  transform: "translate(12 12)"
})));

function SvgDefaultAvatar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_539_12894",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 44,
    height: 44
  }, _ref), _ref2, _ref3, _ref4);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAvatar);
export default __webpack_public_path__ + "static/media/defaultAvatar.66e96d6c35dcc8b60a87ac6b524f4046.svg";
export { ForwardRef as ReactComponent };